<template>
  <div class="dialog_container">
    <el-dialog
      title="编辑车辆信息"
      :visible="dialogShow"
      width="1288px"
      @close="dialogClose"
      top="10vh"
      :close-on-click-modal="false"
    >
      <div class="dialog_box">
        <div class="form_title">基本信息</div>
        <el-form
          ref="redactForm"
          class="add_staff_form"
          :model="redactForm"
          label-width="130px"
          :rules="addRules"
        >
          <el-form-item label="车牌号码：" prop="carNumber">
            <el-input
              v-model="redactForm.carNumber"
              placeholder="请输入车牌号码"
            ></el-input>
          </el-form-item>
          <el-form-item label="车牌颜色：" prop="carColor">
            <el-select
              v-model="redactForm.carColor"
              placeholder="请选择车牌颜色"
            >
              <el-option
                v-for="item in carColorList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="车辆类型：">
            <el-select
              v-model="redactForm.carType"
              placeholder="请选择车辆类型"
            >
              <el-option
                v-for="item in carTypeList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="车辆营运性质：" prop="carService">
            <el-select
              v-model="redactForm.carService"
              placeholder="请选择车辆营运性质"
            >
              <el-option
                v-for="item in carServiceList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="车架号VIN：" prop="vin">
            <el-input
              v-model="redactForm.vin"
              placeholder="请输入车架号VIN"
            ></el-input>
          </el-form-item>
          <el-form-item label="燃油类型：">
            <el-select
              v-model="redactForm.fuelType"
              placeholder="请选择燃油类型"
            >
              <el-option
                v-for="item in fuelTypeList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="车辆厂牌：">
            <el-input
              v-model="redactForm.carFactory"
              placeholder="请输入车辆厂牌"
            ></el-input>
          </el-form-item>
          <el-form-item label="车辆型号：">
            <el-input
              v-model="redactForm.carModel"
              placeholder="请输入车辆型号"
            ></el-input>
          </el-form-item>
          <div class="flex_form">
            <el-form-item label="轴距：">
              <el-input
                class="short_ipt"
                v-model="redactForm.wheelbase"
                placeholder="请输入轴距"
              ></el-input>
              <div class="unit">mm</div>
            </el-form-item>
          </div>
          <div class="flex_box">
            <el-form-item label="长：" class="min_form-item">
              <el-input
                class="min_ipt"
                v-model="redactForm.carLength"
              ></el-input>
              <div class="mm_text">mm X</div>
            </el-form-item>
            <el-form-item label="宽：" class="min_form-item">
              <el-input
                class="min_ipt"
                v-model="redactForm.carWidth"
              ></el-input>
              <div class="mm_text">mm X</div>
            </el-form-item>
            <el-form-item label="高：" class="min_form-item">
              <el-input class="min_ipt" v-model="redactForm.carHigh"></el-input>
              <div class="mm_text">mm</div>
            </el-form-item>
          </div>
          <el-form-item label="发动机号：">
            <el-input
              v-model="redactForm.engineSn"
              placeholder="请输入发动机号"
            ></el-input>
          </el-form-item>
          <el-form-item label="核定座位数：">
            <el-input
              v-model="redactForm.approvedPerson"
              placeholder="请输入核定座位数"
            ></el-input>
          </el-form-item>
          <el-form-item label="车轴数：">
            <el-input
              v-model="redactForm.axleNum"
              placeholder="请输入车轴数"
            ></el-input>
          </el-form-item>
          <div class="flex_form">
            <el-form-item label="满载总质量：" prop="fullyLaden">
              <el-input
                class="short_ipt"
                v-model="redactForm.fullyLaden"
                placeholder="请输入满载总质量"
              ></el-input>
              <div class="unit">kg</div>
            </el-form-item>
          </div>
          <div class="flex_form">
            <el-form-item label="准牵引总质量：">
              <el-input
                class="short_ipt"
                v-model="redactForm.tractionMass"
                placeholder="请输入准牵引总质量"
              ></el-input>
              <div class="unit">kg</div>
            </el-form-item>
          </div>
          <div class="flex_form">
            <el-form-item label="核定载质量：">
              <el-input
                class="short_ipt"
                v-model="redactForm.approvedLaden"
                placeholder="请输入核定载质量"
              ></el-input>
              <div class="unit">kg</div>
            </el-form-item>
          </div>
          <div class="flex_form">
            <el-form-item label="整备质量：">
              <el-input
                class="short_ipt"
                v-model="redactForm.curbWeight"
                placeholder="请输入整备质量"
              ></el-input>
              <div class="unit">kg</div>
            </el-form-item>
          </div>

          <el-form-item label="所属企业：">
            <el-input
              v-model="redactForm.companyName"
              placeholder="请输入所属企业"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="行驶证初领日期：" prop="driverTimeStr">
            <el-date-picker
              v-model="redactForm.driverTimeStr"
              type="date"
              placeholder="请选择行驶证初领日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="行驶证有效期：">
            <el-date-picker
              v-model="redactForm.driverEndTimeStr"
              type="date"
              placeholder="请选择行驶证有效期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="车辆登记证号：">
            <el-input
              v-model="redactForm.carRegisterNumber"
              placeholder="请输入车辆登记证号"
            ></el-input>
          </el-form-item>
          <el-form-item label="车辆状态：">
            <el-radio-group v-model="redactForm.carState">
              <el-radio :label="1">有效</el-radio>
              <el-radio :label="2">无效</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="发动机型号：">
            <el-input
              v-model="redactForm.engineModel"
              placeholder="请输入发动机型号"
            ></el-input>
          </el-form-item>
          <div class="flex_form">
            <el-form-item label="发动机功率：">
              <el-input
                class="short_ipt"
                v-model="redactForm.enginePower"
                placeholder="请输入发动机功率"
              ></el-input>
              <div class="unit">kw</div>
            </el-form-item>
          </div>
          <el-form-item label="登记证发证日期：">
            <el-date-picker
              v-model="redactForm.registerTimeStr"
              type="date"
              placeholder="请选择登记证发证日期"
            >
            </el-date-picker>
          </el-form-item>

          <div class="form_title">车辆道路运输证信息</div>
          <el-form-item label="道路运输证：">
            <el-input
              v-model="redactForm.roadTransportNumber"
              placeholder="请输入道路运输证"
            ></el-input>
          </el-form-item>
          <el-form-item label="发证机构：">
             <el-input
              v-model="redactForm.roadOrgStr"
              placeholder="请输入发证机构"
            ></el-input>
          </el-form-item>
          <el-form-item label="证件状态：">
            <el-radio-group v-model="redactForm.roadState">
              <el-radio :label="1">有效</el-radio>
              <el-radio :label="2">无效</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="初领日期：">
            <el-date-picker
              v-model="redactForm.roadTimeStr"
              type="date"
              placeholder="请选择道路运输证初领日期"
            >
            </el-date-picker>
          </el-form-item>
          <div class="start_end_date">
            <el-form-item label="有效期：">
              <template>
                <div class="issue_time">
                  <el-date-picker
                    type="date"
                    placeholder="选择开始时间"
                    v-model="redactForm.roadStartTimeStr"
                    style="width: 100%"
                  ></el-date-picker>
                  <span class="zhi_text">至</span>
                  <el-date-picker
                    type="date"
                    placeholder="选择结束时间"
                    v-model="redactForm.roadEndTimeStr"
                    style="width: 100%"
                  ></el-date-picker>
                </div>
              </template>
            </el-form-item>
          </div>
        </el-form>

        <div class="form_title">挂车信息</div>
        <el-form
          ref="form"
          class="add_staff_form"
          :model="redactForm"
          label-width="130px"
        >
          <el-form-item label="挂车车牌：">
            <el-input
              v-model="redactForm.trailerCarNumber"
              placeholder="请输入道路运输证"
            ></el-input>
          </el-form-item>
          <el-form-item label="车辆营运性质：">
            <el-select
              v-model="redactForm.trailerCarService"
              placeholder="请选择挂车车辆营运性质"
            >
              <el-option
                v-for="item in carServiceList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="车辆厂牌：">
            <el-input
              v-model="redactForm.trailerLabel"
              placeholder="请输入道挂车车辆厂牌"
            ></el-input>
          </el-form-item>
          <el-form-item label="车架号VIN：">
            <el-input
              v-model="redactForm.trailerVin"
              placeholder="请输入挂车车架号VIN"
            ></el-input>
          </el-form-item>
          <div class="flex_form">
            <el-form-item label="挂车核定载质量：" prop="fullyLaden">
              <el-input
                class="short_ipt"
                v-model="redactForm.trailerApprovedLaden"
                placeholder="请输入挂车核定载质量"
              ></el-input>
              <div class="unit">kg</div>
            </el-form-item>
          </div>
          <el-form-item label="道路许可证：">
            <el-input
              v-model="redactForm.trailerLicense"
              placeholder="请选择挂车道路许可证"
            ></el-input>
          </el-form-item>

          <div class="form_title">从业人员信息</div>
          <el-form-item label="姓名：">
            <el-select
              v-model="redactForm.driverId1"
              placeholder="请选择人员1"
              @change="driverChange1"
            >
              <el-option
                v-for="item in driverList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="岗位类别：">
            <el-input
              v-model="redactForm.postName1"
              placeholder="选择人员后自动填写"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="手机号码：">
            <el-input
              v-model="redactForm.driverPhone1"
              placeholder="选择人员后自动填写"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="姓名：">
            <el-select
              v-model="redactForm.driverId2"
              placeholder="请选择人员2"
              @change="driverChange2"
            >
              <el-option
                v-for="item in driverList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="岗位类别：">
            <el-input
              v-model="redactForm.postName2"
              placeholder="选择人员后自动填写"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="手机号码：">
            <el-input
              v-model="redactForm.driverPhone2"
              placeholder="选择人员后自动填写"
              disabled
            ></el-input>
          </el-form-item>

          <div class="form_title">其他</div>
          <el-form-item label="备注：" class="textarea_form">
            <el-input
              type="textarea"
              :rows="3"
              v-model="redactForm.remark"
              placeholder="请输入备注"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="btn" @click="dialogClose">取 消</el-button>
        <el-button class="btn btn_ok" @click="confirm('redactForm')"
          >保 存</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { dateTransition } from "@/utils/util";
export default {
  name: "",
  data() {
    return {
      textarea: "",
      redactForm: {
        approvedLaden: 0,
        approvedPerson: 0,
        axleNum: 0,
        carColor: 0,
        carFactory: "",
        carHigh: "",
        carId: 0,
        carLength: "",
        carModel: "",
        carNumber: "",
        carRegisterNumber: "",
        carService: 0,
        carState: 0,
        carType: "",
        carWidth: "",
        companyId: 0,
        companyName: "",
        curbWeight: 0,
        driverEndTimeStr: "",
        driverId1: 0,
        driverId2: 0,
        driverStartTimeStr: "",
        driverTimeStr: "",
        engineModel: "",
        enginePower: "",
        engineSn: "",
        fuelType: 0,
        fullyLaden: 0,
        registerTimeStr: "",
        remark: "",
        roadEndTimeStr: "",
        roadOrgId: 0,
        roadOrgStr:"",
        roadStartTimeStr: "",
        roadState: 0,
        roadTimeStr: "",
        roadTransportNumber: "",
        tractionMass: 0,
        trailerApprovedLaden: 0,
        trailerCarNumber: "",
        trailerCarService: 0,
        trailerLabel: "",
        trailerLicense: "",
        trailerVin: "",
        vin: "",
        wheelbase: 0,
      },
      addRules: {
        carNumber: [
          { required: true, message: "请输入车牌号码", trigger: "blur" },
        ],
        carColor: [
          { required: true, message: "请选择车牌颜色", trigger: "change" },
        ],
        carService: [
          { required: true, message: "请选择车辆营运性质", trigger: "change" },
        ],
        vin: [{ required: true, message: "请输入车架号VIN", trigger: "blur" }],
        fullyLaden: [
          { required: true, message: "请输入满载总质量", trigger: "blur" },
        ],
        driverTimeStr: [
          {
            required: true,
            message: "请选择行驶证初领日期",
            trigger: "change",
          },
        ],
      },
      carColorList: [], // 车辆颜色
      carTypeList: [], // 营运性质
      carServiceList: [], // 车辆类型
      fuelTypeList: [], // 燃油类型
      roadOrgList: [], // 发证机构
      driverList: [], // 驾驶员下拉数据
    };
  },
  components: {},
  props: {
    dialogShow: {
      type: Boolean,
      default: false,
    },
    dialogData: {
      type: Object,
      default: {},
    },
  },
  watch: {
    dialogShow(val) {
      if (val) {
        this.$http.getCarDetail({ id: this.dialogData.carId }).then((res) => {
          if (res.code == 0) {
            let data = res.data;
            this.redactForm = data;
            // this.redactForm.carColor = data.carColor;
            // this.redactForm.fuelType = data.fuelType;
            // this.redactForm.driverId1 = data.driverId1;
            // this.redactForm.driverId2 = data.driverId2;
            // this.redactForm.carType = data.carType;
            // this.redactForm.carService = data.carService;
            // this.redactForm.trailerCarService = data.trailerCarServiceStr;
            if(data.carSpecsLong){
              //  carLength carWidth carHigh
              this.redactForm.carLength = data.carSpecsLong;
            }
            if(data.carSpecsWidth){
              //  carLength carWidth carHigh
              this.redactForm.carWidth = data.carSpecsWidth;
            }
            if(data.carSpecsHigh){
              //  carLength carWidth carHigh
              this.redactForm.carHigh = data.carSpecsHigh;
            }
            if (data.driverTime) {
              this.redactForm.driverTimeStr = new Date(data.driverTime);
            }
            if (data.driverEndTime) {
              this.redactForm.driverEndTimeStr = new Date(
                data.driverEndTime
              );
            }
            if (data.registerTime) {
              this.redactForm.registerTimeStr = new Date(data.registerTime);
            }
            if (data.roadTime) {
              this.redactForm.roadTimeStr = new Date(data.roadTime);
            }
            if (data.roadStartTime) {
              this.redactForm.roadStartTimeStr = new Date(
                data.roadStartTime
              );
            }
            if (data.roadEndTime) {
              this.redactForm.roadEndTimeStr = new Date(data.roadEndTime);
            }
            this.$http.getSelect(1).then((res) => {
              if (res.code == 0) {
                this.carColorList = res.data;
              } else {
                this.carColorList = [];
              }
            });
            this.$http.getSelect(2).then((res) => {
              if (res.code == 0) {
                this.carServiceList = res.data;
                this.carTypeList = res.data; // 车辆类型 暂时无接口 先暂用 营运类型的数据
              } else {
                this.carServiceList = [];
                this.carTypeList = [];
              }
            });
            this.$http.getSelect(3).then((res) => {
              if (res.code == 0) {
                this.fuelTypeList = res.data;
              } else {
                this.fuelTypeList = [];
              }
            });
            this.$http.getSelect(4).then((res) => {
              if (res.code == 0) {
                this.roadOrgList = res.data;
              } else {
                this.roadOrgList = [];
              }
            });
            this.$http.getDriverList().then((res) => {
              if (res.code == 0) {
                this.driverList = res.data;
              } else {
                this.driverList = [];
              }
            });
          } else {
            this.redactForm = {};
            this.$message.error(res.msg);
          }
        });
      }
    },
  },
  created() {},
  methods: {
    confirm(formName) {
      if (this.redactForm.wheelbase) {
        if (
          typeof (this.redactForm.wheelbase * 1) == "number" &&
          isNaN(this.redactForm.wheelbase * 1)
        ) {
          this.$message.error("轴距只能是数字");
          return;
        }
      }
      if (
        this.redactForm.carLength ||
        this.redactForm.carWidth ||
        this.redactForm.carHigh
      ) {
        if (
          (typeof (this.redactForm.carLength * 1) == "number" &&
            isNaN(this.redactForm.carLength * 1)) ||
          (typeof (this.redactForm.carWidth * 1) == "number" &&
            isNaN(this.redactForm.carWidth * 1)) ||
          (typeof (this.redactForm.carHigh * 1) == "number" &&
            isNaN(this.redactForm.carHigh * 1))
        ) {
          this.$message.error("长宽高只能是数字");
          return;
        }
      }
      if (this.redactForm.approvedPerson) {
        if (
          typeof (this.redactForm.approvedPerson * 1) == "number" &&
          isNaN(this.redactForm.approvedPerson * 1)
        ) {
          this.$message.error("核定座位数只能是数字");
          return;
        }
      }

      if (this.redactForm.axleNum) {
        if (
          typeof (this.redactForm.axleNum * 1) == "number" &&
          isNaN(this.redactForm.axleNum * 1)
        ) {
          this.$message.error("车轴数只能是数字");
          return;
        }
      }

      if (this.redactForm.fullyLaden) {
        if (
          typeof (this.redactForm.fullyLaden * 1) == "number" &&
          isNaN(this.redactForm.fullyLaden * 1)
        ) {
          this.$message.error("满载总质量只能是数字");
          return;
        }
      }

      if (this.redactForm.tractionMass) {
        if (
          typeof (this.redactForm.tractionMass * 1) == "number" &&
          isNaN(this.redactForm.tractionMass * 1)
        ) {
          this.$message.error("准牵引总质量只能是数字");
          return;
        }
      }
      if (this.redactForm.approvedLaden) {
        if (
          typeof (this.redactForm.approvedLaden * 1) == "number" &&
          isNaN(this.redactForm.approvedLaden * 1)
        ) {
          this.$message.error("核定载质量只能是数字");
          return;
        }
      }
      if (this.redactForm.curbWeight) {
        if (
          typeof (this.redactForm.curbWeight * 1) == "number" &&
          isNaN(this.redactForm.curbWeight * 1)
        ) {
          this.$message.error("整备质量只能是数字");
          return;
        }
      }
      if (this.redactForm.trailerApprovedLaden) {
        if (
          typeof (this.redactForm.trailerApprovedLaden * 1) == "number" &&
          isNaN(this.redactForm.trailerApprovedLaden * 1)
        ) {
          this.$message.error("挂车核定载质量只能是数字");
          return;
        }
      }
      this.$refs[formName].validate((valid) => {
        if (!valid) return false;
        if (this.redactForm.driverTimeStr) {
          this.redactForm.driverTimeStr = dateTransition(
            this.redactForm.driverTimeStr
          );
        }
        if (this.redactForm.driverEndTimeStr) {
          this.redactForm.driverEndTimeStr = dateTransition(
            this.redactForm.driverEndTimeStr
          );
        }
        if (this.redactForm.registerTimeStr) {
          this.redactForm.registerTimeStr = dateTransition(
            this.redactForm.registerTimeStr
          );
        }
        if (this.redactForm.roadTimeStr) {
          this.redactForm.roadTimeStr = dateTransition(
            this.redactForm.roadTimeStr
          );
        }
        if (this.redactForm.roadStartTimeStr) {
          this.redactForm.roadStartTimeStr = dateTransition(
            this.redactForm.roadStartTimeStr
          );
        }
        if (this.redactForm.roadEndTimeStr) {
          this.redactForm.roadEndTimeStr = dateTransition(
            this.redactForm.roadEndTimeStr
          );
        }
        this.$http.updateCarInfo(this.redactForm).then((res) => {
          if (res.code == 0) {
            this.$message.success(res.msg);
            this.$parent.getList();
            this.$emit("update:dialogShow", false);
            this.redactForm = {};
          } else {
            this.$message.error(res.msg);
          }
        });
      });
    },
    dialogClose() {
      this.$emit("update:dialogShow", false);
    },
    driverChange1(e) {
      this.driverList.forEach((i) => {
        if (i.id === e) {
          this.redactForm.postName1 = i.postStr;
          this.redactForm.driverPhone1 = i.phone;
        }
      });
    },
    driverChange2(e) {
      this.driverList.forEach((i) => {
        if (i.id === e) {
          this.redactForm.postName2 = i.postStr;
          this.redactForm.driverPhone2 = i.phone;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/css/dialog";
.textarea_form {
  width: 100%;
  height: 66px;
  /deep/.el-form-item__content {
    width: calc(100% - 130px) !important;
  }
}
/deep/.el-dialog__body{
    max-height: 70vh;
    overflow-y: scroll;
}
</style>



// WEBPACK FOOTER //
// src/views/carAdmin/carInfo_component/redactCar.vue